;$(function() {
    // http://kenwheeler.github.io/slick/
    // https://github.com/kenwheeler/slick/
    if ($.fn.slick) {
        var $slider = $('.slider');

        // slick initialization
        $slider.slick({
            mobileFirst    : true,
            pauseOnHover   : false,
            touchThreshold : 20,
            arrows         : true,
            autoplay       : true,
            autoplaySpeed  : 5000,
            dots           : false,
            nextArrow      : '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
            prevArrow      : '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>'
        });
    }
});